import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { mapSetter } from 'commons/vuex/map/map.js';
import { getContent } from './state.js';
import { isTagRejected } from '@/util/moderation.js';

export const mutations = {
    [MUTATIONS.SET_CONTENT]: mapSetter(Vue, getContent),

    [MUTATIONS.ADD_TAG](state, tag) {
        state[tag.content_id].tags.push(tag);
    },

    [MUTATIONS.UPDATE_TAG_STATUS](state, { content_id, tag_name, status }) {
        Vue.set(state[content_id].tags.find((tag) => tag.tag_name === tag_name), 'status', status);
    },

    [MUTATIONS.UPDATE_ALL_TAG_STATUS](state, { content_id, status }) {
        // don't update rejected tags! Rejected tags should not suddenly appear again!
        state[content_id].tags.filter((tag) => !isTagRejected(tag)).forEach((tag) => {
            Vue.set(tag, 'status', status);
        });
    },

    [MUTATIONS.CHANGE_PROCESSING_STATUS](state, { content_id, status }) {
        Vue.set(state[content_id], 'processing_status', status);
    },

    [MUTATIONS.UPDATE_CONTENT_TAG_CHANGED](state, { content_id, status }) {
        Vue.set(state[content_id], 'have_tags_changed', status);
    },
    [MUTATIONS.SET_BULK_SELECTED](state, { content_id, is_bulk_selected }) {
        Vue.set(state[content_id], 'is_bulk_selected', is_bulk_selected);
    },

    [MUTATIONS.ADD_CONTENT_ACTION](state, action) {
        state[action.content_id].actions.push(action);
    },
};
